import { useContext } from 'react';
import { ThemeContext } from '@utils/providers/theme-context.tsx';

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error(
      'useThemeContext must be used within <ThemeProvider></ThemeProvider>'
    );
  }

  return context;
};
